import { useParams } from '@redwoodjs/router'
import { MetaTags } from '@redwoodjs/web'

import PartHistoryCell from "src/components/PartHistoryCell"

import { rwUrlDecode } from 'src/lib/util';

const PartPage = () => {
  const partNumber = useParams().partNumber!
  const n = rwUrlDecode(decodeURI(partNumber));
  return (
    <>
      <MetaTags title={"#" + n} description="Part history page" />
      <div className='max-w-[1200px] mx-auto px-6 pb-12 pt-6'>
        <PartHistoryCell partNumber={n}/>
      </div>
    </>
  )
}

export default PartPage
